"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var version_1 = __importDefault(require("../version"));
var version = version_1.default
    .split('.')
    .reverse()
    .reduce(function (acc, value, idx) {
    var numValue = parseInt(value, 10);
    var shiftVal = idx * 8;
    // Bitwise works really well here
    // eslint-disable-next-line no-bitwise
    return acc + (numValue << shiftVal);
}, 0) + 0x1000000;
exports.default = version;
//# sourceMappingURL=getPackageVersion.js.map